export var TicketType;
(function (TicketType) {
    TicketType["BASE"] = "base";
    TicketType["QUOTA_REQUEST"] = "quota_request";
    TicketType["PODCAST_REQUEST"] = "podcast_request";
    TicketType["PODCAST_CLAIM_OWNERSHIP"] = "podcast_claim_ownership";
    TicketType["PODCAST_REFETCH"] = "podcast_refetch";
})(TicketType || (TicketType = {}));
